import { FLEXIBLE_CHECK_IN_OUT } from '~/constants'
import checkinCheckoutI18n from '~~/i18n/locales/common/rv/checkin-checkout.json'

interface UseRvCheckinCheckoutArgs {
  checkInStartTime: Ref<Nullable<number>>
  checkInEndTime: Ref<Nullable<number>>
  checkOutStartTime: Ref<Nullable<number>>
  checkOutEndTime: Ref<Nullable<number>>
  isStatic: Ref<boolean>
}

export default function useRvCheckinCheckout({ checkInStartTime, checkInEndTime, checkOutStartTime, checkOutEndTime, isStatic }: UseRvCheckinCheckoutArgs) {
  const { t } = useI18n({
    useScope: 'global',
    messages: checkinCheckoutI18n,
  })
  const { translateTime } = useDates()

  function getTimeFormatted(start: Nullable<number>, end: Nullable<number>, key: 'checkIn' | 'checkOut' | 'drop-off' | 'pickup') {
    if ((!start && !end) || (start === FLEXIBLE_CHECK_IN_OUT && end === FLEXIBLE_CHECK_IN_OUT)) {
      return t(`${key}.flexible`)
    }
    else if ((start !== null && end !== null) && start > FLEXIBLE_CHECK_IN_OUT && end > FLEXIBLE_CHECK_IN_OUT) {
      return t(`${key}.from`, {
        Start: translateTime(start),
        End: translateTime(end),
      })
    }
    else if ((start !== null && end !== null) && start > FLEXIBLE_CHECK_IN_OUT) {
      return t(`${key}.after`, { Time: translateTime(start) })
    }
    else {
      return t(`${key}.before`, { Time: translateTime(end || 0) })
    }
  }

  const rvCheckInTimeFormatted = computed(() => getTimeFormatted(checkInStartTime.value, checkInEndTime.value, isStatic.value ? 'checkIn' : 'pickup'))

  const rvCheckOutTimeFormatted = computed(() => getTimeFormatted(checkOutStartTime.value, checkOutEndTime.value, isStatic.value ? 'checkOut' : 'drop-off'))

  return {
    rvCheckInTimeFormatted,
    rvCheckOutTimeFormatted,
  }
}
